<template>
  <div class="transaction position-relative">
    <div
      class="position-absolute modal d-flex justify-content-center align-items-center"
      v-if="displayUpload"
    >
      <div
        :style="{
          backgroundColor: 'white',
          padding: '20px',
          position: 'absolute',
        }"
        style="z-index: 100000"
        class="col-md-6"
      >
        <div class="upload-products">
          <a
            target="_blank"
            href="https://docs.google.com/spreadsheets/d/e/2PACX-1vThr7jyJMMiPSXuoXal0Iunl1NP2lGrl03krRjc-ObEuqg9uYrCgpHVvPG3eVSvYyseLj6wVv5fLw8d/pub?gid=0&single=true&output=csv"
            class="btn btn-warning btn-sm"
            >Download Upload Template</a
          >
          <button
            class="btn btn-danger btn-sm"
            style="float: right"
            @click="closeUploadItems"
          >
            Close
          </button>
          <div class="form">
            <label for="upload-products mt-5 mb-5"
              >Choose product file (CSV) to upload <i class="fa fa-upload"></i
            ></label>
            <input
              type="file"
              class="form-control"
              id="upload-products"
              placeholder="Upload Products"
              accept=".csv"
              ref="fileUpload"
              @change="handleFileChange"
            />
          </div>
        </div>
      </div>
    </div>

    <Header :mainHeader="true" />

    <section id="transaction-products" style="padding: 10px 0px !important">
      <div class="containers">
        <h5 class="fw-bold">
          Item Management
          <button
            class="pull-right btn btn-primary"
            style="float: right; margin: 10px"
            @click="openModal"
          >
            Add Item
          </button>
          <button
            class="pull-right btn btn-default"
            style="float: right; margin: 10px; border: 1px solid #000"
            @click="uploadItems"
          >
            Upload Items
          </button>
          <!-- <button class="pull-right btn btn-primary" style="float:right;margin:10px;" @click="getItemCodes">Pull Classification Codes</button> -->

          <div
            class="col-md-6 align-self-center"
            :style="{
              display: displayStock,
              backgroundColor: '#fff',
              border: '1px solid #000',
              padding: '20px',
              position: 'absolute',
              marginLeft: '200px',
              borderRadius: '5px',
            }"
          >
            <div class="upload-products">
              <h4>
                Adjust Item stock
                <button
                  class="btn btn-danger btn-sm"
                  style="float: right"
                  @click="closeAdjust"
                >
                  Close
                </button>
              </h4>
              <hr />
              <div class="form">
                <div class="form-group">
                  <label for="">Select Adjustment Reason</label>
                  <select v-model="adjustmentId" style="width: 100%">
                    <option value="2">Incoming Adjustment</option>
                    <option value="4">Outgoing Adjustment</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="">Quantity to Adjust </label>
                  <input
                    type="number"
                    min="0"
                    v-model="adjustQty"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <button class="btn-style full" @click="postAdjust">
                    Adjust Stock
                  </button>
                </div>
              </div>
            </div>
          </div>
        </h5>

        <div
          style="width: 100%; margin-top: 40px"
          v-if="showAddModal"
          class="modal-container"
        >
          <h4 class="p-20">Add Item</h4>
          <hr />
          <div class="row p-30">
            <div class="col-md-6">
              <label for="">Item Classification</label>

              <v-select
                v-if="classifications.length"
                v-model="classification"
                :options="classifications"
                label="itemClsNm"
                :reduce="(classific) => classific.itemClsCd"
                placeholder="Select Classification"
              ></v-select>
              <p for="" v-else>Wait. Loading ...</p>

              <label for="">Product Type</label>
              <v-select
                v-if="codes[9]"
                v-model="productType"
                :options="codes[9].dtlList"
                label="cdNm"
                :reduce="(objItem) => objItem.cd"
                placeholder="Select Product Type"
              ></v-select>
              <p for="" v-else>Wait. Loading ...</p>

              <label for="">Country of Origin</label>
              <v-select
                v-if="codes[1]"
                v-model="country"
                :options="codes[1].dtlList"
                label="cdNm"
                :reduce="(objItem) => objItem.cd"
                placeholder="Select Country of Origin"
              ></v-select>
              <p for="" v-else>Wait. Loading ...</p>

              <label for="">Packaging Unit</label>
              <v-select
                v-if="codes[8]"
                v-model="packagingUnit"
                :options="codes[8].dtlList"
                label="cdNm"
                :reduce="(objItem) => objItem.cd"
                placeholder="Select Packaging Unit"
              ></v-select>
              <p for="" v-else>Wait. Loading ...</p>

              <label for="">Quantity Unit</label>
              <v-select
                v-if="codes[4]"
                v-model="quantityUnit"
                :options="codes[4].dtlList"
                label="cdNm"
                :reduce="(objItem) => objItem.cd"
                placeholder="Select Quantity Unit"
              ></v-select>
              <p for="" v-else>Wait. Loading ...</p>

              <label for="">Tax type</label>
              <v-select
                v-if="codes[0]"
                v-model="taxType"
                :options="filteredCodeList"
                label="cdNm"
                :reduce="(objItem) => objItem.cd"
                placeholder="Select Tax Type"
              ></v-select>
              <p for="" v-else>Wait. Loading ...</p>

              <button
                class="btn btn-primary"
                style="margin-top: 20px"
                @click="postItem"
              >
                <div
                  v-if="loading"
                  class="spinner-border text-light text-sm mr-4"
                  role="status"
                  style="margin-right: 10px"
                ></div>
                <span class="text-light">Add Item</span>
              </button>
              <button
                class="btn btn-danger"
                style="margin-top: 20px; margin-left: 20px"
                @click="closeModal"
              >
                Close
              </button>
            </div>

            <div class="col-md-6">
              <label for="">Item Name</label>
              <input
                type="text"
                v-model="name"
                class="form-control"
                style="background: #fff; border: 1px solid #000"
              />
              <label for="">Barcode</label>
              <input
                type="text"
                v-model="barcode"
                class="form-control"
                style="background: #fff; border: 1px solid #000"
              />
              <label for="">Batch No.</label>
              <input
                type="text"
                v-model="batch"
                class="form-control"
                style="background: #fff; border: 1px solid #000"
              />
              <label for="">Price</label>
              <input
                type="number"
                min="0"
                v-model="price"
                class="form-control"
                style="background: #fff; border: 1px solid #000"
              />
              <label for="">Declare Initial Stock</label>
              <input
                type="number"
                min="0"
                v-model="stock"
                class="form-control"
                style="background: #fff; border: 1px solid #000"
              />
            </div>
          </div>
        </div>

        <div class="table-container" v-if="!showAddModal">
          <table
            class="table table-hover"
            style="width: 100% !important"
            id="itemsTable"
          >
            <thead>
              <tr>
                <th>No</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Price</th>
                <th>Tax Code</th>
                <th>Current Stock</th>
                <th>Action</th>
              </tr>
            </thead>
            <!--<tbody v-if="items.length > 0">
                <tr v-for="(item,index) in items" v-bind:key="item.id">
                    <td>{{ index+1 }}</td>
                    <td>{{ item.itemCd }}</td>
                    <td>{{ item.itemNm }}</td>
                    <td>KES {{ formatToMoney(item.dftPrc) }}</td>
                    <td>{{ item.taxTyCd }}</td>
                    <td>{{ formatToMoney(item.currentStock) }}</td>
                    < <td><button class="btn btn-primary btn-sm" @click="openModalComposition(item)">Send Composition</button></td> 
                    <td>
                      <div class="btn-group" role="group">
                        <button type="button" class="btn btn-default btn-sm" style="border: 1px solid #000;" data-bs-toggle="dropdown" aria-expanded="true">Action</button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" @click="viewAdjust(item.id)">Adjust Stock</a></li>
                        </ul>
                      </div>
                    </td>
                </tr>
               
            </tbody>
            <p v-else  style="color: red; padding: 20px; font-size: 21px;">No Items found</p>-->
          </table>
          <LoaderItem v-if="loading" />
        </div>
      </div>
    </section>

    <div v-show="isVisible" class="modal">
      <div class="modal-content">
        <span
          class="close"
          style="
            position: absolute;
            width: fit-content;
            right: 0;
            margin-right: 20px;
          "
          @click="closeModalComposition"
          >&times;</span
        >
        <div class="row">
          <h4>
            Selected item to setup composition: {{ currentItem.itemName }}
          </h4>
          <div class="col-md-5">
            <label for="">Select Item for Composition</label>
            <select
              v-model="itemComposition"
              style="width: 98%"
              v-if="items"
              class="form-control"
            >
              <option
                v-for="objItem in items"
                v-bind:key="objItem.id"
                :value="objItem"
              >
                {{ objItem.itemNm }}
              </option>
            </select>
          </div>
          <div class="col-md-7">
            <label for="">Quantity composed</label>
            <input
              type="number"
              min="1"
              v-model="quantity"
              class="form-control"
            />
          </div>
        </div>
        <button
          class="btn-style"
          style="float: right; margin: 20px"
          @click="sendComposition"
        >
          Send Composition
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
select {
  padding: 7px;
}
</style>

<script>
import Header from "../../components/Header";
import Swal from "sweetalert2";
import { toRaw } from "vue";
import "datatables.net-vue3";
import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import $ from "jquery";
import "jszip";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.print.js";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { formatDate } from "../../utils/commons";
import LoaderItem from "../../components/LoaderItem.vue";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "ItemPage",
  components: {
    Header,
    LoaderItem,
  },
  data() {
    return {
      token: JSON.parse(localStorage.getItem("access_token")),
      items: [],
      processedData: [],
      showAddModal: false,
      classifications: [],
      codes: [],
      classification: "",
      adjustmentId: "",
      adjustQty: "",
      productType: "",
      country: "",
      packagingUnit: "",
      quantityUnit: "",
      taxType: "",
      name: "",
      barcode: "",
      batch: "",
      price: "",
      stock: "",
      isVisible: false,
      currentItem: {},
      itemComposition: {},
      quantity: "",
      displayUpload: false,
      displayStock: "none",
      uploadProduct: "",
      adjustItemId: "",
      loading: false,

      classificationSearch: "",
      productTypeSearch: "",
      countrySearch: "",
      packagingUnitSearch: "",
      quantityUnitSearch: "",
    };
  },
  methods: {
    openModal() {
      this.showAddModal = true;
    },
    closeModal() {
      this.showAddModal = false;
      this.getItems();
    },
    openModalComposition(obj) {
      this.isVisible = true;
      this.currentItem = toRaw(obj);
    },
    closeModalComposition() {
      this.isVisible = false;
    },

    viewAdjust(id) {
      alert(id);
      console.log("View Adjusted");
      console.log(id);
      this.displayStock = "block";
      this.adjustItemId = id;
    },

    async postItem() {
      if (this.name != "" && this.price != "" && this.taxType != "") {
        const itemcds =
          this.country +
          this.productType +
          this.packagingUnit +
          this.quantityUnit +
          this.classification +
          "1";
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.token,
          },
          body: JSON.stringify({
            itemCd: itemcds + "1",
            itemCdDf: itemcds,
            itemClsCd: this.classification,
            itemTyCd: this.productType,
            itemNm: this.name,
            orgnNatCd: this.country,
            pkgUnitCd: this.packagingUnit,
            qtyUnitCd: this.quantityUnit,
            taxTyCd: this.taxType,
            btchNo: this.batch,
            bcd: this.barcode,
            currentStock: this.stock,
            dftPrc: this.price,
          }),
        };
        this.name = "";
        this.price = "";
        this.taxType = "";

        try {
          this.loading = true;
          const res = await fetch(
            process.env.VUE_APP_URL + "/items",
            requestOptions
          );
          const data = await res.json();

          if (data.status === true) {
            Swal.fire({
              icon: "success",
              title: "Item added successfully",
              text: data.message,
            });

            // Reset form fields
            this.name = "";
            this.barcode = "";
            this.batch = "";
            this.price = "";
            this.stock = "";

            // Additional actions after successful item addition
            this.closeModal(); // this.getItems();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: data.message || "Failed to add item",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while adding the item.",
          });
          console.error("Error:", error);
        } finally {
          this.loading = false;
        }
      }
    },
    async postAdjust() {
      if (this.adjustQty != "" && this.adjustmentId != "") {
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.token,
          },
          body: JSON.stringify({
            itemId: this.adjustItemId,
            reasonId: this.adjustmentId,
            qty: this.adjustQty,
          }),
        };
        this.adjustQty = "";
        this.adjustmentId = "";
        const res = await fetch(
          process.env.VUE_APP_URL + "/stock/adjust",
          requestOptions
        );
        const data = await res.json();
        if (data.status == true) {
          Swal.fire({
            icon: "success",
            title: "Item stock adjusted successfully",
            text: data.message,
          });
          this.displayStock = "none";
          this.getItems();
        } else {
          Swal.fire({
            icon: "error",
            title: "Item not found",
            text: data.message,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Missing Fields or Data",
          text: "Fill in all the fields ",
        });
      }
    },
    async getItems() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };

      try {
        this.loading = true;
        const res = await fetch(
          process.env.VUE_APP_URL + "/items",
          requestOptions
        );
        const data = await res.json();
        if (data.status === true) {
          this.items = data.items;
          console.log(this.items);
          this.processedData = this.preprocessData(this.items);
          this.initializeDataTable();
        } else {
          Swal.fire({
            icon: "error",
            title: "Items not found",
            text: data.message,
          });
        }
      } catch (error) {
        console.log(error);
        // console.error('Error fetching or parsing data:', error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch items. Please try again later.",
        });
      } finally {
        this.loading = false;
      }
    },

    preprocessData(rawData) {
      return rawData.map((item) => {
        return {
          indexNo: "1",
          itemCode: item.itemCd,
          itemName: item.itemNm,
          price: this.formatToMoney(item.dftPrc),
          taxCode: item.taxTyCd,
          currentStock: this.formatToMoney(item.currentStock),
          action: "",
        };
      });
    },

    renderActionButton(data, type, row) {
      if (type === "display") {
        let action = "";
        action += `<button type="button" class="btn btn-default btn-sm" style="border: 1px solid #000;" @click="viewAdjust(${row.id})">Adjust Stock</button>`;

        return action;
      }
      return data;
    },

    initializeDataTable() {
      try {
        this.dataTable = $(this.$el)
          .find("#itemsTable")
          .DataTable({
            responsive: true,
            language: {
              paginate: {
                previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
              },
            },
            dom: '<"datatable-buttons"B><"datatable-search"f>tip',
            buttons: [
              {
                extend: "colvis",
                text: "Column Visibility",
                className: "btn-grey",
              },
              {
                extend: "pageLength",
                text: "Page Length",
                className: "btn-grey",
              },
              {
                extend: "csv",
                text: "Export CSV",
                className: "btn-grey",
                exportOptions: {
                  columns: ":visible",
                },
              },
              {
                extend: "pdfHtml5",
                text: "Export PDF",
                orientation: "landscape",
                className: "btn-grey",
                exportOptions: {
                  columns: ":visible",
                },
                customize: this.customizePDF,
              },
            ],
            data: this.processedData,
            columns: [
              { data: null },
              { data: "itemCode" },
              { data: "itemName" },
              { data: "price" },
              { data: "taxCode" },
              { data: "currentStock" },
              { data: "action", render: this.renderActionButton },
            ],
            columnDefs: [
              {
                targets: 0,
                searchable: true,
                orderable: true,
                render: (data, type, row, meta) => {
                  return meta.row + 1;
                },
              },
            ],
          });
      } catch (error) {
        console.log({ error });
      }
    },

    customizePDF(doc) {
      //const logoBase64 = this.convertToBase64(logo)
      //console.log(logoBase64)
      doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
      doc.defaultStyle.columnGap = 0;
      doc.content[1].fillColor = "#f2f2f2";

      (doc.header = () => {
        return {
          columns: [
            {
              width: "*",
              columns: [
                /* {
                        image: logoBase64,
                        width: 150, // Adjust the width as needed
                    },*/
                {
                  text: "Taxpoint",
                  alignment: "left",
                  margin: [40, 15, 0, 40], // Adjust margins as needed
                  color: "#000",
                  bold: true,
                  fontSize: 14,
                },
              ],
            },
            {
              width: "*",
              stack: [
                {
                  text: "Items List",
                  alignment: "right",
                  margin: [0, 15, 50, 0],
                  fontSize: 12,
                  color: "#4448B3",
                },
                {
                  alignment: "right",
                  margin: [300, 0, 0, 0],
                  width: "*",
                  columns: [
                    {
                      width: "auto",
                      text: "Date:",
                      alignment: "right",
                      margin: [0, 0, 10, 0],
                      bold: true,
                    },
                    {
                      width: "auto",
                      text: `${formatDate(new Date(), "true")}`,
                      alignment: "right",
                      margin: [0, 0, 50, 0],
                      fontSize: 9,
                    },
                  ],
                },
              ],
            },
          ],
          fillColor: "#000000",
        };
      }),
        (doc.footer = (currentPage, pageCount) => {
          return {
            columns: [
              { width: "*", text: "www.pavicongroup.co.ke", alignment: "left" },
              {
                width: "*",
                text: "contact@pavicongroup.co.ke",
                alignment: "center",
              },
              {
                width: "*",
                text: `Page ${currentPage} of ${pageCount}`,
                alignment: "center",
              },
              {
                width: "*",
                text: `Printed on ${formatDate(new Date(), "true")}`,
                alignment: "right",
              },
            ],
            margin: [40, 10, 40, 10], // Margin for the whole footer
            fillColor: "black",
          };
        });

      doc.styles.title = {
        color: "#4448B3",
        fontSize: 13,
        margin: [80, 0, 0, 40],
      };
    },

    uploadItems() {
      this.displayUpload = true;
    },
    closeUploadItems() {
      this.displayUpload = false;
    },
    closeAdjust() {
      this.displayStock = "none";
    },
    async getCodes() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      const res = await fetch(
        process.env.VUE_APP_URL + "/items/pullcodes",
        requestOptions
      );
      const data = await res.json();
      console.log({ data });
      this.codes = data.kraResult?.clsList;
      // console.log(data)
      // if(data.status == true){
      //     this.codes = data.kraResult
      // }
    },
    async getClassifications() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      const res = await fetch(
        process.env.VUE_APP_URL + "/items/pullclassifications",
        requestOptions
      );
      const data = await res.json();
      console.log({ data });
      this.classifications = data.kraResult.itemClsList;
      // console.log(data)
      // if(data.status == true){
      //     this.classifications = data.kraResult
      // }
    },
    async getItemCodes() {
      this.getCodes();
      this.getClassifications();
    },
    formatToMoney(value) {
      const formattedValue = Number(value).toFixed(2);
      return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async uploadProducts() {
      try {
        let formData = new FormData();
        formData.append("file", this.uploadProduct);

        const response = await fetch(
          process.env.VUE_APP_URL + "/items/upload",
          {
            method: "POST",
            body: formData,
            headers: {
              Authorization: "Bearer " + this.token,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.status === true) {
          await Swal.fire({
            icon: "success",
            title: "Products uploaded successfully",
            text: data.message,
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Confirm",
          });

          window.location.reload();
        } else {
          await Swal.fire({
            icon: "error",
            title: "Product upload failed",
            text: data.message,
          });
        }
      } catch (error) {
        console.error("Error during product upload:", error);
        await Swal.fire({
          icon: "error",
          title: "Product upload failed",
          text: "An error occurred during the upload process. Please try again later.",
        });
      }
    },
    handleFileChange() {
      this.uploadProduct = this.$refs.fileUpload.files[0];
    },
  },

  mounted() {
    this.getItems();
    this.getItemCodes();
    $("#itemsTable").on("click", ".action-btn", (event) => {
      const itemId = $(event.currentTarget).data("item-id");
      this.viewAdjust(itemId);
    });
  },
  computed: {
    filteredCodeList() {
      return this.codes[0].dtlList.filter((objItem) => objItem.cd != "E");
    },
  },
  watch: {
    uploadProduct() {
      this.uploadProducts();
    },
  },
};
</script>

<style scoped>
.v-select :deep(.vs__dropdown-toggle) {
  border: 1px solid #b3d9ff !important;
}

.v-select {
  width: 98%;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>
